var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesktop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5C1.34315 1.5 0 2.84315 0 4.5V15C0 16.6569 1.34315 18 3 18H21C22.6569 18 24 16.6569 24 15V4.5C24 2.84315 22.6569 1.5 21 1.5H3ZM3 3C2.17157 3 1.5 3.67157 1.5 4.5V15C1.5 15.8284 2.17157 16.5 3 16.5H21C21.8284 16.5 22.5 15.8284 22.5 15V4.5C22.5 3.67157 21.8284 3 21 3H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5H22.5V12H1.5V10.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18H10.5V22.5H9V18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18H15V22.5H13.5V18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 23.25C4.5 22.8358 4.83579 22.5 5.25 22.5H18.75C19.1642 22.5 19.5 22.8358 19.5 23.25V23.25C19.5 23.6642 19.1642 24 18.75 24H5.25C4.83579 24 4.5 23.6642 4.5 23.25V23.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesktop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/desktop.51cb96116eb95ec1ff0a8668e38b8a96.svg";